import useCookieConsent from '@modules/modules/CookieConsent/components/Context';
import { useEffect, useState } from 'react';

const ConsentReactor = ({ execute, services }) => {
  const te = useCookieConsent();
  const isEnabled = services.filter(x => !te.services.includes(x)).length === 0;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (isEnabled && isMounted) {
      window.dataLayer.push({
        event: 'initial',
        services: te.services,
        type: 'cookie-consent',
      });
    }

    setIsMounted(true);

    if (isEnabled) {
      execute();
    }
  }, [te.services]);

  return null;
};

export default ConsentReactor;
